<template>
  <div class="lv-time-duration-picker">
    <LvText
      v-if="title"
      h6
      bold
      class="lv-time-duration-picker__title"
    >
      {{ $t(title) }}<span v-if="required">*</span>
    </LvText>
    <div class="lv-time-duration-picker__content-wrapper">
      <div
        v-for="(duration, durationIndex) in _value"
        :key="durationIndex"
        class="lv-time-duration-picker__content"
      >
        <TimePicker
          v-model="duration.start"
          :required="required"
          :rules="rules"
          class="lv-time-duration-picker__time mr-10"
        />
        <div class="lv-time-duration-picker__dash"> {{'-'}} </div>
        <TimePicker
          v-model="duration.end"
          :required="required"
          :rules="rules"
          class="lv-time-duration-picker__time mr-10"
        />
        <i
          v-if="_value.length > 1"
          class="lv-time-duration-picker__icon icon-delete"
          @click.stop="$_onDelete(durationIndex)"
        />
      </div>
    </div>
    <WsButton001
      v-if="multiple"
      out-line
      class="mt-10"
      @click="$_onAdd()"
    >
      {{ $t('增加時間區間') }}
    </WsButton001>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    value: {
      type: Array,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
  },
  computed: {
    _value() {
      return [...this.value];
    }
  },
  methods: {
    $_onAdd() {
      this.$emit('add');
    },
    $_onDelete(index) {
      this.$emit('delete', index);
    }
  }
}
</script>